import script from "./CandidatesListV2.vue?vue&type=script&setup=true&lang=js"
export * from "./CandidatesListV2.vue?vue&type=script&setup=true&lang=js"

import "./CandidatesListV2.vue?vue&type=style&index=0&id=52550e08&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52550e08"]])

export default __exports__